import { Component, forwardRef, Renderer2, ViewChild, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { StationService } from '../../../service/station/station.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Station } from '../../../class/station';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectStationsComponent),
  multi: true,
};

@Component({
  selector: 'app-multiselect-stations',
  templateUrl: './multiselect-stations.component.html',
  styleUrls: ['./multiselect-stations.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class MultiSelectStationsComponent implements ControlValueAccessor {
    @Input() stationsId: Station[];
    @ViewChild('input') textarea;

    public stations: AbstractControl;
    public stationsSelected: SelectItem[];
    public stationOptions: SelectItem[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public stationService: StationService
    ) {
        this.page = 1;
        this.per_page = 5000;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getStations(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.value);
        this.onTouched($event.value);
    }

    getStations(query?: string, filters?: any[]) {
        this.stationService.getStation(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const stations = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.stationOptions = [];
                stations.forEach(element => {
                    this.stationOptions.push({'value': element.id, 'label': element.name});
                });

                if (this.stationsId) {
                    this.stationsSelected = [];
                    this.stationsId.forEach(element => {
                        this.stationsSelected.push({'value': element.id, 'label': element.name});
                    });
                }
            },
            error => {
                this.stationOptions = [];
                this.stationOptions.push({value: '', label: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/stations/multiselect-stations/multiselect-stations.component.ts